import { render } from "./YearRadioGroup.vue?vue&type=template&id=46c708f4&scoped=true"
import script from "./YearRadioGroup.vue?vue&type=script&lang=js"
export * from "./YearRadioGroup.vue?vue&type=script&lang=js"

import "./YearRadioGroup.vue?vue&type=style&index=0&id=46c708f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c708f4"]])

export default __exports__